import PERMISSIONS from './permissions'

export const NO_MATCH = {
  label: 'No Match',
  path: '*',
  key: 'no-match',
}

export const BRANDS = {
  label: 'Brand curation tasks',
  fullPath: '/brand-curation-tasks',
  path: 'brand-curation-tasks',
  key: 'brand-curation-tasks',
  isNavigationTab: true,
  permissions: [PERMISSIONS.BRAND_CURATION_TASK.LIST],
  children: {
    BRAND_DETAILS: {
      label: 'Brand curation task details',
      fullPath: '/brand-curation-tasks',
      path: ':id',
      key: 'brand-curation-task-details',
      permissions: [
        PERMISSIONS.BRAND_CURATION_TASK.GET,
        PERMISSIONS.BRAND_CURATION_TASK.UPDATE,
      ],
    },
  },
}

export const MENUS = {
  label: 'Menu curation tasks',
  fullPath: '/menu-curation-tasks',
  path: 'menu-curation-tasks',
  key: 'menu-curation-tasks',
  isNavigationTab: true,
  permissions: [PERMISSIONS.MENU_CURATION_TASK.LIST],
  children: {
    MENU_DETAILS: {
      label: 'Menu curation task details',
      fullPath: '/menu-curation-tasks',
      path: ':id',
      key: 'menu-curation-task-details',
      permissions: [
        PERMISSIONS.MENU_CURATION_TASK.GET,
        PERMISSIONS.MENU_CURATION_TASK.UPDATE,
      ],
    },
  },
}

export const ACCOUNT = {
  label: 'Account',
  fullPath: '/account',
  path: 'account',
  key: 'account',
  children: {
    LOGIN: {
      fullPath: '/account/login',
      path: 'login',
      key: 'login',
      label: 'Login',
    },

    LOGIN_EMAIL: {
      fullPath: '/account/login-email',
      path: 'login-email',
      key: 'login-email',
      label: 'Login Email',
    },

    LOGOUT: {
      label: 'Logout',
      fullPath: '/account/logout',
      path: 'logout',
      key: 'logout',
    },

    SETTINGS: {
      label: 'Settings',
      fullPath: '/account/settings',
      path: 'settings',
      key: 'settings',
    },
  },
}

export const MISC = {
  label: 'Misc',
  key: 'misc',
  isNavigationTab: true,
  children: {
    USERS: {
      label: 'Users',
      fullPath: '/misc/users',
      path: 'users',
      key: 'users',
      permissions: [PERMISSIONS.USER.LIST],
      isNavigationTab: true,
      shouldOpenInNewTab: true,
      children: {
        USER_CREATE: {
          label: 'User Create',
          fullPath: '/misc/users/create',
          path: 'create',
          key: 'user-create',
          permissions: [PERMISSIONS.USER.CREATE],
        },
        USER_DETAILS: {
          label: 'User Details',
          fullPath: '/misc/users/:id',
          path: ':id',
          key: 'user-details',
          permissions: [PERMISSIONS.USER.GET, PERMISSIONS.USER.UPDATE],
        },
      },
    },
    ABOUT: {
      label: 'About',
      fullPath: '/misc/about',
      path: 'about',
      key: 'about',
      isNavigationTab: true,
      shouldOpenInNewTab: true,
    },
    SOPS: {
      label: 'Documentation',
      fullPath: '/misc/sops',
      path: 'sops',
      key: 'sops',
      permissions: [PERMISSIONS.SOP.CREATE],
      isNavigationTab: true,
      shouldOpenInNewTab: true,
      children: {
        SOP_CREATE: {
          label: 'SOP Create',
          fullPath: '/misc/sops/create',
          path: 'create',
          key: 'sop-create',
        },
      },
    },
    PRIORITY_TASKS: {
      label: 'Priority tasks',
      fullPath: '/misc/priority-tasks',
      path: 'priority-tasks',
      key: 'priority-tasks',
      isNavigationTab: true,
      permissions: [PERMISSIONS.PRIORITY_TASK.CREATE],
      shouldOpenInNewTab: false,
      children: {
        PRIORITY_TASK_DETAILS: {
          label: 'Priority task details',
          fullPath: '/misc/priority-tasks/:id',
        },
      },
    },
    TARGETED_DB_FLASH: {
      label: 'Targeted DB flash',
      fullPath: '/misc/targeted-db-flash',
      path: 'targeted-db-flash',
      key: 'targeted-db-flash',
      isNavigationTab: true,
      permissions: [PERMISSIONS.MENU_CURATION_TASK.START_TARGETED_DB_FLASH],
      shouldOpenInNewTab: false,
      isHiddenBasedOnPermissions: true,
    },
    REPORTS: {
      label: 'Reports',
      key: 'reports',
      isNavigationTab: true,
      shouldOpenInNewTab: false,
      children: {
        MENU_DATA: {
          label: 'Menu Data',
          fullPath: '/misc/reports/menu-data',
          path: 'menu-data',
          key: 'menu-data',
          isNavigationTab: true,
          shouldOpenInNewTab: false,
        },
      },
    },
  },
}
